import React from 'react';
import './styles/global.scss';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './auth/authConfig';
import { queryClient } from './services/core/QueryClient';
import { AppProviders } from './providers/AppProviders';
import { AppRoutes } from './router';
import { registerGlobalErrorHandlers } from './utils/globalErrorHandler';

const msalInstance = new PublicClientApplication(msalConfig);
registerGlobalErrorHandlers();

async function initializeApp() {
  try {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('Error initializing MSAL or handling redirect promise:', error);
    }
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AppProviders msalInstance={msalInstance} queryClient={queryClient}>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AppProviders>
    </React.StrictMode>,
  );
}

initializeApp();
